
    import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
    import Util from '../../../lib/util'
    import AbpBase from '../../../lib/abpbase'
    import IntoLogisticsCheckResult from '@/store/entities/Into-logistics-checkresult';
    import storeaddressInfo from '@/store/entities/back-storeaddress-list';
    import appconst from '@/lib/appconst';
    import QRcode from 'qrcodejs2'
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)

    class EditLogistics {
        id: number;
        storeId: number;
        shipment: string;
    }

    @Component({
        name: "rejectionLogisticsCheck",
    })
    export default class CreateLogisticsModule extends AbpBase {
        @Prop({ type: Boolean, default: false }) value: boolean;
        logistics: EditLogistics = new EditLogistics();
        warehouseCityId: number = 0;
        titleList: Array<string> = [];
        checkLoding: boolean;
        storeaddressList: Array<storeaddressInfo> = [];
        async created() {
            await this.$store.dispatch({
                type: 'backstoreaddress/getAll',
                data: {}
            })
            this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
            this.logistics.storeId = this.storeaddressList[0].id;
            var data: any = this.$refs.inputshipment;
            data.focus();
        }


        async NumberClick(ev) {
            if (ev.code == "Enter") {
                ev.preventDefault();  
                this.checkExpress();
            }
        }

        async enter() {
        //    alert(this.logistics.shipment);
            //this.logistics.shipment = "";
            this.checkExpress();
        }

        async checkExpress() {
            this.$Modal.remove();
            var audio: any = document.getElementById("myAudio");
            var qsAudio: any = document.getElementById("qsAudio");
            audio.pause();  
            if (this.logistics.shipment) {
                this.logistics.shipment = this.logistics.shipment.toUpperCase();
            }
            var shipMent = this.logistics.shipment;
            if (!shipMent && shipMent.length == 0) {
                return;
            }

            if (!this.logistics.storeId) {
                this.$Message.error('仓库不能为空。');
                return;
            }
            var data = { Shipment: shipMent, StoreId: this.logistics.storeId };
            var checkResult = await this.$store.dispatch({
                type: 'backabroadlogistics/rejectionCheck',
                data: this.logistics
            });
            this.titleList = [];
            this.titleList.push(data.Shipment);
            if (checkResult.isRejection || checkResult.isCancle) {
                if (checkResult.isRejection) {
                    this.titleList.push("拒收申请（ปฏิเสธการสมัคร）");
                }
                if (checkResult.isCancle) {
                    this.titleList.push("订单取消（การยกเลิกคำสั่งซื้อ）");
                }
                audio.play();
                this.$Modal.error({
                    title: "拒收包裹（ปฏิเสธพัสดุ）",
                    content: data.Shipment
                });
            } else {
                qsAudio.play();
            }
            this.logistics.shipment = "";

            var inputshipmentData: any = this.$refs.inputshipment;
            inputshipmentData.focus();
        }
    }
